import React, { useEffect, useState } from 'react';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

import { IconButton } from '@mui/material';
import { eventList, glb_sv } from 'src/utils';
const FullScreenButton = () => {
    const [fullscreen, setFullscreen] = useState(false);

    useEffect(() => {
        const handleFullscreenChange = () => {
            const isCurrentlyFS = !!(
                document.fullscreenElement ||
                document.mozFullScreenElement ||
                document.webkitFullscreenElement ||
                document.msFullscreenElement
            );
            setFullscreen(isCurrentlyFS);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        const subscription = glb_sv.commonEvent.subscribe((msg) => {
            if (msg.type === eventList.ZOOM_SCREEN) {
                if (msg.data !== undefined) {
                    setFullscreen(!!msg.data);
                } else {
                    toggleFullScreen();
                }
            };
        });

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
            subscription.unsubscribe();
        };
    }, [])

    useEffect(() => {
        const isCurrentlyFS = !!(
            document.fullscreenElement ||
            document.mozFullScreenElement ||
            document.webkitFullscreenElement ||
            document.msFullscreenElement
        );
        if (fullscreen && !isCurrentlyFS) {
            enterFullScreen();
        } else if (!fullscreen && isCurrentlyFS) {
            exitFullScreen();
        }
    }, [fullscreen]);

    const enterFullScreen = () => {
        const docEl = document.documentElement;
        const requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullscreen || docEl.msRequestFullscreen;

        if (requestFullScreen) {
            requestFullScreen.call(docEl).catch(err => {
                // console.log(err);
                // enableIOSFullScreenFallback();
                setFullscreen(false);
            });
        } else {
            enableIOSFullScreenFallback();
        }
    };

    const exitFullScreen = () => {
        const cancelFullScreen = document.exitFullscreen || document.mozCancelFullScreen || document.webkitExitFullscreen || document.msExitFullscreen;

        if (
            document.fullscreenElement || 
            document.mozFullScreenElement || 
            document.webkitFullscreenElement || 
            document.msFullscreenElement
        ) {
        if (cancelFullScreen) {
            cancelFullScreen.call(document).catch(err => {
            // console.log(err);
            // disableIOSFullScreenFallback();
            setFullscreen(true)
            });
        } else {
            disableIOSFullScreenFallback();
        }
        } else {
            disableIOSFullScreenFallback();
        }
    };

    const enableIOSFullScreenFallback = () => {
        const docEl = document.documentElement;
        const viewportMeta = document.querySelector("meta[name=viewport]");

        if (viewportMeta) {
        viewportMeta.setAttribute("data-original-content", viewportMeta.getAttribute("content"));
        viewportMeta.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
        }

        docEl.style.position = "";
        docEl.style.top = "0";
        docEl.style.left = "0";
        docEl.style.width = "100%";
        docEl.style.height = "100%";
        docEl.style.overflow = "auto";
    };

    const disableIOSFullScreenFallback = () => {
        const docEl = document.documentElement;
        const viewportMeta = document.querySelector("meta[name=viewport]");

        if (viewportMeta && viewportMeta.hasAttribute("data-original-content")) {
        viewportMeta.setAttribute("content", viewportMeta.getAttribute("data-original-content"));
        viewportMeta.removeAttribute("data-original-content");
        }

        docEl.style.position = "";
        docEl.style.top = "";
        docEl.style.left = "";
        docEl.style.width = "";
        docEl.style.height = "";
        docEl.style.overflow = "";
    };

    const toggleFullScreen = () => {
        setFullscreen(prev => !prev);
    };
    // const toggleFullScreen = () => {
    //     if (
    //         !document.fullscreenElement &&
    //         !document.mozFullScreenElement &&
    //         !document.webkitFullscreenElement &&
    //         !document.msFullscreenElement
    //     ) {
    //         if (document.documentElement.requestFullscreen) {
    //             document.documentElement.requestFullscreen();
    //         } else if (document.documentElement.msRequestFullscreen) {
    //             document.documentElement.msRequestFullscreen();
    //         } else if (document.documentElement.mozRequestFullScreen) {
    //             document.documentElement.mozRequestFullScreen();
    //         } else if (document.documentElement.webkitRequestFullscreen) {
    //             document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
    //         }
    //         setFullscreen(true);
    //     } else {
    //         if (document.exitFullscreen) {
    //             document.exitFullscreen();
    //         } else if (document.msExitFullscreen) {
    //             document.msExitFullscreen();
    //         } else if (document.mozCancelFullScreen) {
    //             document.mozCancelFullScreen();
    //         } else if (document.webkitExitFullscreen) {
    //             document.webkitExitFullscreen();
    //         }
    //         setFullscreen(false);
    //     }
    // };

    return (
        <IconButton color="default" onClick={toggleFullScreen} sx={{ width: 40, height: 40 }}>
            {fullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </IconButton>
    );
};
export default FullScreenButton;
